<div class="form-container"  *ngIf="!cargaDatos1">
  <!-- estado-entrega.component.html -->
  <div class="progress-container">
    <!-- Paso 1 -->
    <div
            class="progress-step"
            [class.active]="estadoActual >= 1"
    >
      1
    </div>
    <div
            class="progress-line"
            [class.active]="estadoActual >= 2"
    ></div>

    <!-- Paso 2 -->
    <div
            class="progress-step"
            [class.active]="estadoActual >= 2"
    >
      2
    </div>
    <div
            class="progress-line"
            [class.active]="estadoActual >= 3"
    ></div>

    <!-- Paso 3 -->
    <div
            class="progress-step"
            [class.active]="estadoActual >= 3"
    >
      3
    </div>
  </div>
  <p class="progress-text">{{this.estadoTexto}}</p>
</div>

<div class="container-spiner" *ngIf="cargaDatos1">
  <mat-spinner></mat-spinner>
</div>
